import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { hyphenate } from '../../../Shared/features/hyphenate';
import { partition } from '../../../Shared/utils/list';
import { Link } from './library/link';
import { classNamesConfig } from '../../../Shared/features/classnames';
export const SubscriptionsBlock = (props)=>{
    const [youthTiers, adultTiers] = partition(props.items, (x)=>x.isYouth);
    const adultListType = adultTiers.count() > 1 ? 'multiple' : 'single';
    const youthListType = youthTiers.count() > 1 ? 'multiple' : 'single';
    const classNames = classNamesConfig().subscription_block;
    return /*#__PURE__*/ _jsx("section", {
        className: `block block--subscriptions ${classNames.block}`,
        children: /*#__PURE__*/ _jsxs("ul", {
            className: "block__inner",
            children: [
                /*#__PURE__*/ _jsx("li", {
                    className: "block__group",
                    children: adultTiers.count() > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            youthTiers.isEmpty() ? /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsx("h2", {
                                className: "block__title title--s",
                                children: "Ben je 18 jaar of ouder?"
                            }),
                            /*#__PURE__*/ _jsx("ul", {
                                className: `block__list block__list--${adultListType} count--${adultTiers.count()}`,
                                children: adultTiers.map((item)=>/*#__PURE__*/ _jsx("li", {
                                        className: "block__item subscription",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            className: "subscription__inner",
                                            url: item.linkUrl,
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "subscription__content",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "subscription__header title--m",
                                                        children: [
                                                            item.sticker && /*#__PURE__*/ _jsx("span", {
                                                                className: "subscription__sticker",
                                                                children: item.sticker
                                                            }),
                                                            /*#__PURE__*/ _jsx("h3", {
                                                                className: "subscription__title",
                                                                children: hyphenate(item.title)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {}),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "subscription__wrap",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "subscription__benefits",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "sr-text",
                                                                        children: 'Voordelen van het ' + item.title + ' abonnement: '
                                                                    }),
                                                                    item.services && /*#__PURE__*/ _jsx("div", {
                                                                        className: "subscription__text text--styled text--s",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: item.services
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "subscription__text text--styled text--s",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: item.materials
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "subscription__costs",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "subscription__bg",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "sr-text",
                                                                                children: "Kosten van het abonnement: "
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                className: "subscription__price title--l",
                                                                                children: item.price
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                className: "subscription__label text--xs",
                                                                                children: item.extra
                                                                            })
                                                                        ]
                                                                    }),
                                                                    adultTiers.count() == 1 && /*#__PURE__*/ _jsx("div", {
                                                                        className: `button button--arrow subscription__button ${classNames.clickablePrimary === 'black' ? 'button--primary' : 'button--secondary'}`,
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            className: "button__label",
                                                                            children: item.linkTitle
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: `button button--arrow subscription__button ${classNames.clickablePrimary === 'black' ? 'button--primary' : 'button--secondary'}`,
                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                    className: "button__label",
                                                                    children: item.linkTitle
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, item.title))
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: "block__group",
                    children: youthTiers.count() > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "block__title title--s",
                                children: "Ben je jonger dan 18 jaar?"
                            }),
                            /*#__PURE__*/ _jsx("ul", {
                                className: `block__list block__list--${youthListType} count--${youthTiers.count()}`,
                                children: youthTiers.map((item)=>/*#__PURE__*/ _jsx("li", {
                                        className: "block__item subscription",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            className: "subscription__inner",
                                            url: item.linkUrl,
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "subscription__content",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "subscription__header title--m",
                                                        children: [
                                                            item.sticker && /*#__PURE__*/ _jsx("span", {
                                                                className: "subscription__sticker",
                                                                children: item.sticker
                                                            }),
                                                            /*#__PURE__*/ _jsx("h3", {
                                                                className: "subscription__title",
                                                                children: hyphenate(item.title)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "subscription__wrap",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "subscription__benefits",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "sr-text",
                                                                        children: 'Voordelen van het ' + item.title + ' abonnement: '
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "subscription__text text--styled text--s",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: item.materials
                                                                        }
                                                                    }),
                                                                    item.services && /*#__PURE__*/ _jsx("div", {
                                                                        className: "subscription__text text--styled text--s",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: item.services
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "subscription__costs",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "subscription__bg",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "sr-text",
                                                                                children: "Kosten van het abonnement: "
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                className: "subscription__price title--l",
                                                                                children: item.price
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                className: "subscription__label text--xs",
                                                                                children: item.extra
                                                                            })
                                                                        ]
                                                                    }),
                                                                    youthTiers.count() == 1 && /*#__PURE__*/ _jsx("div", {
                                                                        className: `button button--arrow subscription__button ${classNames.clickablePrimary === 'black' ? 'button--primary' : 'button--secondary'}`,
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            className: "button__label",
                                                                            children: item.linkTitle
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: `button button--arrow subscription__button ${classNames.clickablePrimary === 'black' ? 'button--primary' : 'button--secondary'}`,
                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                    className: "button__label",
                                                                    children: item.linkTitle
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, item.title))
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                })
            ]
        })
    });
};
{
/* TH: Added to styleguide! */ }